<template>
  <div>
    <b-tabs>
      <b-tab>
        <template #title>
          <feather-icon icon="MapIcon" />
          <span>Zones</span>
        </template>

        <zones-list />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="ToolIcon" />
          <span>Services</span>
        </template>

        <ServicesList />
      </b-tab>
      <!-- :disabled="!($store.getters['zones/zones'].length && $store.getters['services/services'].length)" -->
      <b-tab>
        <template #title>
          <feather-icon icon="ToolIcon" />
          <span>Mapping</span>
        </template>

        <ZonesServicesMapping v-if="$store.getters['zones/zones'].length && $store.getters['services/services'].length" />
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="ToolIcon" />
          <span>Configurations</span>
        </template>

        <ZonesConfigurations v-if="$store.getters['zones/zones'].length" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import { onUnmounted } from '@vue/composition-api'
import ServicesList from '@/views/services/ServicesList.vue'
import ZonesList from '@/views/zones/ZonesList.vue'
import ZonesServicesMapping from '@/views/zones/ZonesServicesMapping.vue'
import store from '@/store'
import zoneStoreModule from '@/views/zones/zoneStoreModule'
import serviceStoreModule from '@/views/services/serviceStoreModule'
import ZonesConfigurations from './zones/ZonesConfigurations.vue'

export default {
  components: {
    ZonesServicesMapping,
    BTabs,
    BTab,
    ZonesConfigurations,
    ZonesList,
    ServicesList,
  },
  setup() {
    // Register Zone Module
    const ZONE_APP_STORE_MODULE_NAME = 'zones'

    // Register module
    if (!store.hasModule(ZONE_APP_STORE_MODULE_NAME)) {
      store.registerModule(ZONE_APP_STORE_MODULE_NAME, zoneStoreModule)
    }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(ZONE_APP_STORE_MODULE_NAME)) store.unregisterModule(ZONE_APP_STORE_MODULE_NAME)
    })

    // Register Services Module
    const SERVICE_APP_STORE_MODULE_NAME = 'services'

    // Register module
    if (!store.hasModule(SERVICE_APP_STORE_MODULE_NAME)) store.registerModule(SERVICE_APP_STORE_MODULE_NAME, serviceStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(SERVICE_APP_STORE_MODULE_NAME)) store.unregisterModule(SERVICE_APP_STORE_MODULE_NAME)
    })
  },
}
</script>

<style scoped>

</style>
